class Feeding{

    constructor(){
        this.feeding = [
            { id:0, name: "安置無餵食" }, { id:1, name: "短暫滯留餵食" }, { id:2, name: "滯留多日" }
            , { id:3, name: "飼養已久" }, { id:4, name: "僅懷疑/無法取得紀錄" }
        ];
    }

    getFeeding(){
        return this.feeding;
    }

}

export default Feeding;